function normalizeConfirmName(value: string): string {
  return value.normalize('NFC').trim().replace(/\s+/g, ' ').toLocaleLowerCase();
}

/**
 * Delete confirmation: the typed name must match, but case and repeated
 * whitespace don't count. Emojis and other characters still do (DEV-548).
 */
export function matchesConfirmName(input: string, expected: string): boolean {
  return normalizeConfirmName(input) === normalizeConfirmName(expected);
}
